// src/components/Footer.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/Footer.css';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const whatsappUrl =
    'https://wa.me/34687474802?text=Hola%2C%20quiero%20saber%20m%C3%A1s%20informaci%C3%B3n%20sobre%20ser%20distribuidor%20en%20Reanimeitor.';

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!email) return;

    setStatus('loading');
    setMessage('');

    try {
      const response = await axios.post(
        '/backend/newsletter/suscribir.php',
        { email, nombre: '' },
        {
          headers: { 'Content-Type': 'application/json' },
          timeout: 10000
        }
      );

      if (response.data.success) {
        setStatus('success');
        setMessage(response.data.message || 'Te has suscrito correctamente.');
        setEmail('');

        setTimeout(() => {
          setStatus('idle');
          setMessage('');
        }, 5000);
      } else {
        setStatus('error');
        setMessage(response.data.message || 'Error al suscribir');

        setTimeout(() => {
          setStatus('idle');
          setMessage('');
        }, 5000);
      }
    } catch (error) {
      console.error('Error:', error);
      setStatus('error');
      setMessage('Error de conexión con el servidor');

      setTimeout(() => {
        setStatus('idle');
        setMessage('');
      }, 5000);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-energy-bg">
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div className="footer-container">
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="footer-distributor-banner"
          aria-label="Solicitar información para ser distribuidor de Reanimeitor por WhatsApp"
        >
          <img
            src="/Assets/popup.jpeg"
            alt="Banner distribuidor Reanimeitor"
            className="footer-distributor-image"
          />

          <div className="footer-distributor-overlay">
            <div className="footer-distributor-text">
              <small>Haz clic y habla con Reanimeitor por WhatsApp</small>
            </div>

            <div className="footer-distributor-button">
              Contactar
            </div>
          </div>
        </a>

        <div className="newsletter-section">
          <div className="newsletter-copy">
            <span className="newsletter-kicker">REANIMEITOR NEWS</span>
            <h3 className="newsletter-title">Mantente energizado</h3>
            <p>
              Recibe novedades, promociones y noticias de Reanimeitor Energy Drink.
            </p>
          </div>

          <div className="newsletter-action">
            {message && (
              <div className={`newsletter-message ${status}`}>
                {status === 'success' && '✅'}
                {status === 'error' && '⚠️'}
                <span>{message}</span>
              </div>
            )}

            <form className="newsletter-form" onSubmit={handleSubscribe}>
              <input
                type="email"
                placeholder="tu@email.com"
                className="newsletter-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={status === 'loading' || status === 'success'}
                required
              />

              <button
                type="submit"
                className="newsletter-btn"
                disabled={status === 'loading' || status === 'success'}
              >
                {status === 'loading'
                  ? 'Enviando...'
                  : status === 'success'
                    ? '¡Suscrito!'
                    : 'Suscribirse'}
              </button>
            </form>
          </div>
        </div>

        <div className="footer-main">
          <div className="footer-brand">
            <Link to="/" className="footer-logo" aria-label="Ir al inicio de Reanimeitor">
              <span className="footer-logo-icon">⚡</span>
              <span className="footer-logo-text">REANIMEITOR</span>
            </Link>

            <p className="footer-description">
              Bebida energética con actitud, sabor y presencia para quienes buscan
              una energía diferente.
            </p>

            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-whatsapp-cta"
            >
              Ser distribuidor
            </a>
          </div>

          <div className="footer-links">
            <div className="link-group">
              <h4>Productos</h4>
              <a href="/#elige-tu-carga">Todos los productos</a>
            </div>

            <div className="link-group">
              <h4>Empresa</h4>
              <Link to="/about">Sobre nosotros</Link>
              <a href="https://reanimeitor.com/soporte/">Contacto</a>
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                Distribuidores
              </a>
            </div>

            <div className="link-group">
              <h4>Cliente</h4>
              <Link to="/login">Iniciar sesión</Link>
              <Link to="/register">Crear cuenta</Link>
              <Link to="/account">Mi cuenta</Link>
            </div>

            <div className="link-group">
              <h4>Legal</h4>
              <Link to="/aviso-legal">Aviso legal</Link>
              <Link to="/politica-privacidad">Privacidad</Link>
              <Link to="/politica-cookies">Cookies</Link>
              <Link to="/politica-tienda">Términos tienda</Link>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="payment-methods">
            <span>Métodos de pago</span>
            <div className="payment-icons">
              <span title="Tarjeta de crédito" aria-label="Tarjeta de crédito">
                💳
              </span>
            </div>
          </div>

          <div className="footer-copyright">
            <div>© 2026 Reanimeitor. Todos los derechos reservados.</div>
            <div className="design-credit">
              Desarrollado con <strong>energía</strong> y actitud.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;